import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { ComponentSize, InputMessageType } from '../../atoms';
import { LabelPosition } from './types';

export const Container = styled.div<{
  labelPosition: LabelPosition;
  fullWidth: boolean;
}>`
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};
  width: 100%;
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'FormField', 'labelPosition')
    )};
`;

export const MessageContainer = styled.div<{ type: InputMessageType }>`
  ${({ theme, type }) => css`
    min-height: ${theme.lineHeights[
      theme.components.InputMessage.componentVariants.type.variants[type]
        .lineHeight
    ]};
    margin-top: ${theme.space[2]}px;
  `};
`;

export const LabelContainer = styled.div<{
  labelPosition: LabelPosition;
  size: ComponentSize;
}>`
  ${({ labelPosition, size, theme }) =>
    labelPosition === 'left' &&
    css`
      padding-top: ${theme.space[
        theme.components.Input.componentVariants.inputSize.variants[size]
          .paddingTop
      ]}px;
    `};
`;
